var _rect, _path, _path2, _path3, _path4, _path5, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageCardStyleVerticalSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 48,
    viewBox: "0 0 60 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 8,
    width: 32,
    height: 24,
    rx: 1,
    transform: "rotate(90 42 8)",
    fill: "#E7F2F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41 8C41.5523 8 42 8.44772 42 9L42 22L18 22L18 9C18 8.44771 18.4477 8 19 8L41 8Z",
    fill: "#0E7490"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 25H31",
    stroke: "#0E7490",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 29H38",
    stroke: "#0E7490",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 33H38",
    stroke: "#0E7490",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22 37H28",
    stroke: "#0E7490",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 47,
    rx: 1.5,
    stroke: "#0E7490"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageCardStyleVerticalSelected);
export default __webpack_public_path__ + "static/media/image-card-style-vertical-selected.2c60a3d1f2fec7a8d04690925b7efd72.svg";
export { ForwardRef as ReactComponent };